import { FC } from "react";
import { Box } from "@chakra-ui/react";
import { Text } from "../../components/Typography";
import { useCanEnrich } from "hooks/useCanEnrich";
import { DrawerSection } from "./DrawerSection";

const gradientTextColor = "linear-gradient(94deg, #DA1B7D 1.16%, #FF643A 100%)";

export const AvailableCredits: FC = () => {
  const { canEnrich, availableCredits } = useCanEnrich();

  if (!canEnrich) {
    return null;
  }

  return (
    <Box mt="40px">
      <DrawerSection>
        <Box display="flex" flexDirection="row" gap="4px" alignItems="flex-end">
          <Text
            fontSize="32px"
            fontStyle="normal"
            fontWeight="800"
            lineHeight="110%"
            letterSpacing="-0.32px"
            background={gradientTextColor}
            backgroundClip="text"
          >
            {availableCredits}
          </Text>
          <Text
            fontSize="14px"
            fontStyle="normal"
            fontWeight="400"
            lineHeight="150%"
            background={gradientTextColor}
            backgroundClip="text"
          >
            Available Credits
          </Text>
        </Box>
      </DrawerSection>
    </Box>
  );
};
